export default __webpack_public_path__ + "static/xbox-series-x-99262e60c86d72dda52394913b30d0e3.png";